import { SIDEBAR_CONFIG } from '@modules/showroom/Sidebar/common'
import { ENHANCED_VIEW_ROUTES } from '@modules/showroom/productCollection/enhancedView/constants/cnf-product-constants'
import { stores } from '@stores'
import find from 'lodash/find'
import { action, computed, observable } from 'mobx'
import qs from 'query-string'

export class ShowroomSidebarStore {
  @observable campaignId = null
  @observable anchorEl = null

  @action setCampaignId = campaignId => {
    this.campaignId = campaignId
  }

  @action
  handleClick = event => {
    this.anchorEl = event.currentTarget
  }

  @action
  handleClose = () => {
    this.anchorEl = null
  }

  @action redirectToPage = (url: string, queryParams?) => {
    const {
      nav: { history }
    } = stores
    if (history?.location?.pathname !== url) {
      if (this.anchorEl) this.handleClose()
      history.push({
        pathname: url,
        search: qs.stringify(queryParams)
      })
    }
  }

  @action onShowroomTabClick = (queryParams?) => {
    const {
      productConfiguration: { enableEnhancedViewByDefault }
    } = stores
    let url = SIDEBAR_CONFIG.presentation.url
    if (!queryParams?.campaignId) {
      if (enableEnhancedViewByDefault) {
        url = SIDEBAR_CONFIG.enhancedLookbook.url
      } else {
        url = SIDEBAR_CONFIG.lookbook.url
      }
    }
    this.redirectToPage(url, queryParams)
  }

  @computed get activePath() {
    const {
      nav: {
        location: { pathname }
      }
    } = stores
    // need one match only, hence find
    return find(SIDEBAR_CONFIG, key => pathname.endsWith(key.url))
  }

  /** Handle BSG selection, if presentation is present, 
      route to it else check if looks are present, 
      then route to lookbook page else route to collection
  **/
  handleBSGSelection =
    (id, retailStatus = '', campaignId) =>
    async e => {
      const {
        nav: {
          queryParams: { clientId, clientType },
          history,
          location: { pathname }
        },
        productConfiguration: { enableEnhancedViewByDefault }
      } = stores
      this.setCampaignId(campaignId)
      if (campaignId) {
        history.push({
          pathname: `${pathname}/presentation`,
          search: qs.stringify({
            clientId,
            buyingSessionGroupId: id,
            campaignId: campaignId,
            clientType
          })
        })
      } else {
        try {
          const {
            showroomDashboardStore: { setActiveLookMap, isActiveLookPresent }
          } = stores
          await setActiveLookMap(id)
          if (isActiveLookPresent(id)) {
            const navPath = `${pathname}/${
              enableEnhancedViewByDefault ? ENHANCED_VIEW_ROUTES.lookbook : 'lookbook'
            }`
            history.push({
              pathname: navPath,
              search: qs.stringify({
                clientId,
                buyingSessionGroupId: id,
                clientType
              })
            })
          } else {
            const {
              clientCollection: { url },
              enhancedClientCollection: { url: enhancedViewURL }
            } = SIDEBAR_CONFIG
            history.push({
              pathname: enableEnhancedViewByDefault ? enhancedViewURL : url,
              search: qs.stringify({
                clientId,
                buyingSessionGroupId: id,
                clientType
              })
            })
          }
        } catch (e) {
          // incase of error in activeLookMap API, still navigate to collection page
          const {
            clientCollection: { url },
            enhancedClientCollection: { url: enhancedViewURL }
          } = SIDEBAR_CONFIG
          history.push({
            pathname: enableEnhancedViewByDefault ? enhancedViewURL : url,
            search: qs.stringify({
              clientId,
              buyingSessionGroupId: id,
              clientType
            })
          })
        }
      }
    }
}

export const showroomSidebarStore = new ShowroomSidebarStore()
